<template>
  <el-upload :action="baseURL + action" :headers="headers" :show-file-list="false" :auto-upload="autoupload" :accept="accept" :limit="2" :data="{ ObjectId: objectId, Mode: mode }" :before-upload="handleBeforeUpload" :on-success="handlecoverSuccess">
    <slot></slot>
    <div class="content">
      <el-image v-if="image.url" class="cover" :src="image.url" fit="cover" />
      <i v-else class="el-icon-plus single-upload-icon"></i>
    </div>
  </el-upload>
</template>

<script>
export default {
  data () {
    return {
      baseURL: process.env.VUE_APP_API,
      image: {},
      headers: {
        "Authorization": `Bearer ${this.$utils.cookies.get('token')}`,
        "X-Authorization": `Bearer ${this.$utils.cookies.get('refresh_token')}`
      },
    }
  },
  props: {
    action: {
      type: String,
      default: '/api/System/File/UploadFile',
    },
    objectId: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: null,
    },
    accept: {
      type: String,
      default: '.jpg,.png',
    },
    autoupload: {
      type: Boolean,
      default: true,
    },
  },
  mounted () {
    this.initData()
  },
  methods: {
    //加载已上传的图片
    initData () {
      this.$apis.system.file.list({
        objectId: this.objectId,
        mode: this.mode
      }).then((res) => {
        if (res.length > 0) {
          this.image = res[0]
        }
      })
    },
    //上传前回调
    handleBeforeUpload () {
      //删除之前上传的文件
      if (this.image.url) {
        return this.$confirm('此操作将替换之前上传的图片, 是否继续?', '提示', {
          type: 'warning',
          center: true,
        }).then(() => {
          return this.$apis.system.file.delete({ id: this.image.id })
        })
      }
    },
    //上传成功回调
    handlecoverSuccess (res) {
      this.image = res.result
    },
  },
}
</script>

<style>
.el-upload {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-upload.el-upload:hover {
  border-color: #409eff;
}
.single-upload-icon {
  font-size: 28px;
  color: #ddd;
  width: 100%;
  height: 100%;
}
.cover {
  width: 100%;
  height: 100%;
}
.el-upload .content {
  width: 200px;
  height: 200px;
  line-height: 200px;
  margin: 20px auto;
}
</style>
